import styled from 'styled-components';

const StyledChildrenWrapper = styled.div``;

export default StyledChildrenWrapper;
